import { Permission } from '@infrastructure/authorization/constants';
import { RoutesType } from './types';

export const filterPagesByPermissions = (routes: RoutesType, userPermissions: Permission[], isAuthenticated: boolean) =>
  routes.filter(({ permissions }) => {
    if (permissions === undefined) return true;
    if (permissions.length === 0) return isAuthenticated;
    return permissions.some((p) => userPermissions.includes(p));
  });
